var CalculationAction;
(function (CalculationAction) {
    CalculationAction[CalculationAction["Edit"] = 1] = "Edit";
    CalculationAction[CalculationAction["SendToVerifier"] = 2] = "SendToVerifier";
    CalculationAction[CalculationAction["SendToApprover"] = 3] = "SendToApprover";
    CalculationAction[CalculationAction["Reject"] = 4] = "Reject";
    CalculationAction[CalculationAction["Approve"] = 5] = "Approve";
    CalculationAction[CalculationAction["CloseForSubmissionNonUniversalRole"] = 6] = "CloseForSubmissionNonUniversalRole";
    CalculationAction[CalculationAction["CloseForSubmissionUniversalRole"] = 7] = "CloseForSubmissionUniversalRole";
    CalculationAction[CalculationAction["ReopenNonUniversalRole"] = 8] = "ReopenNonUniversalRole";
    CalculationAction[CalculationAction["ReopenUniversalRole"] = 9] = "ReopenUniversalRole";
    CalculationAction[CalculationAction["ConfirmSubmission"] = 10] = "ConfirmSubmission";
    CalculationAction[CalculationAction["ApproveReopening"] = 11] = "ApproveReopening";
    CalculationAction[CalculationAction["RejectReopening"] = 12] = "RejectReopening";
    CalculationAction[CalculationAction["Recall"] = 13] = "Recall";
    CalculationAction[CalculationAction["Assign"] = 14] = "Assign";
    CalculationAction[CalculationAction["View"] = 15] = "View";
    CalculationAction[CalculationAction["Delete"] = 16] = "Delete";
})(CalculationAction || (CalculationAction = {}));
export default CalculationAction;
